import { Button, Col, Form, Input, message, Row, Select } from "antd";
import { useEffect, useState } from "react";
import leadLogo from "../../assets/whiteLogo.png";
import IntlPhoneInput from "../../components/IntlPhoneInput";
import ContactInput from "../../components/ContactInput";
import AxiosService from "../../services/APIService";
function WhiteLabelInquiryForm() {
  const apiService = new AxiosService();
  // const [searchParams] = useSearchParams();
  // const white_label = searchParams.get("wlid");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState({
    formLoading: false,
    otpLoading: false,
  });
  const [country , setCountry] = useState("auto");
  const [brokers, setBrokers] = useState([]);
  const [showCustomBroker, setShowCustomBroker] = useState(false);

  const getBrokerList = () => {
    apiService
      .get("/subcategories")
      .then(({ data }) => {
        setBrokers(data || []);
      })
      .catch((error) => {
        message.error("Failed to load brokers list");
      });
  };

  useEffect(() => {
    getBrokerList()
  }, []);

  const onFinish = (val) => {
    setLoading({ ...loading, formLoading: true });
    if (showCustomBroker && val.categoryName) {
      apiService
        .post("/categories", { categoryName: val.categoryName })
        .then((response) => {
          val.broker_subcategory = response?.payload?._id;
          apiService
            .post("/admin/white-label-lead-inquiries", { ...val })
            .then(({ data }) => {
              message.success("Lead Created Successfully");
              getBrokerList()
              form.resetFields();
              setShowCustomBroker(false);
            })
            .catch((e) => {
              message.error(e.message || "Failed to submit form");
            })
            .finally(() => {
              setLoading({ ...loading, formLoading: false });
            });
          setShowCustomBroker(false);
          setCountry("auto");
        })
        .catch((error) => {
          setLoading({ ...loading, formLoading: false });
          setCountry("auto");
        });
    }else {
      apiService
        .post("/admin/white-label-lead-inquiries", { ...val })
        .then(({ data }) => {
          message.success("Lead Created Successfully");
          getBrokerList()
          form.resetFields();
          setShowCustomBroker(false);
        })
        .catch((e) => {
          message.error(e.message || "Failed to submit form");
        })
        .finally(() => {
          setLoading({ ...loading, formLoading: false });
          setCountry("auto");
        });
    }
  };

  return (
    <>
      <div className="main-layer-box">
        <div className="main-header-layer">
          <div className="cus-container">
            <div className="logo-alignment">
              <p>Sponsor By</p>
              <img src={leadLogo} alt="leadLogo"></img>
            </div>
            <h2>B2B Forex Club</h2>
            <h3>15,000+ Members. One Global Network</h3>
            <h4>Connecting IBs, Traders, Investors & Brokers to grow together.</h4>
          </div>
        </div>
        <div className="center-alignment-box">
          <div className="alignment-page">
            <div className="top-bottom-alignment">
              <div className="spacing">
                <div className="find-text">
                  <p>Fill in your details to join the network.</p>
                </div>
                <Form name="lead" onFinish={onFinish} autoComplete="off" layout="vertical" form={form}>
                  <div className="bottom-spacing broker-select-style">
                    <div className="first-width">
                      {!showCustomBroker ? (
                        <Form.Item name="broker_subcategory">
                          <Select
                            showSearch
                            placeholder="Search and select a broker"
                            optionFilterProp="children"
                            size="large"
                            filterOption={(input, option) => (option?.label?.toLowerCase() || "").includes(input.toLowerCase())}
                            options={brokers?.map((broker) => ({
                              value: broker._id,
                              label: broker.name,
                              key: broker._id,
                            }))}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item name="categoryName">
                          <Input size="large" placeholder="Enter broker name" autoFocus />
                        </Form.Item>
                      )}
                    </div>
                    <div className="borker-type-button" type="text" onClick={() => setShowCustomBroker(!showCustomBroker)}>
                      {!showCustomBroker ? "Broker" : "Other"}
                    </div>
                  </div>
                  <div className="bottom-spacing">
                    <Form.Item name="register_as">
                      <Select
                        placeholder="Select a Option"
                        size="large"
                        options={[
                          { value: "Broker", label: "Broker" },
                          { value: "SD", label: "SD" },
                          { value: "RM", label: "RM" },
                          { value: "TL", label: "TL" },
                          { value: "BDM", label: "BDM" },
                          { value: "IB", label: "IB" },
                          { value: "Investor", label: "Investor" },
                          { value: "Trader", label: "Trader" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="two-col-grid">
                    <Form.Item name="prefix">
                      <Select
                        placeholder="Select a Option"
                        defaultValue="Mr"
                        size="large"
                        options={[
                          { value: "Mr", label: "Mr" },
                          { value: "Ms", label: "Ms" },
                          { value: "Mrs", label: "Mrs" },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item name="full_name">
                      <Input size="large" placeholder="Enter your full name" />
                    </Form.Item>
                  </div>
                  <div className="two-col bottom-spacing">
                    <Form.Item name="personal_number" style={{ marginBottom: 0 }}>
                      <IntlPhoneInput 
                        form={form} 
                        name="personal_number" 
                        placeholder="Enter your personal number" 
                        required={false} 
                        defaultCountry={country ?? "auto"} 
                      />
                    </Form.Item>
                    <Form.Item name="phone_number" style={{ marginBottom: 0 }}>
                      <IntlPhoneInput 
                        form={form} 
                        name="phone_number" 
                        placeholder="Enter your phone number" 
                        required={false} 
                        defaultCountry={country ?? "auto"} 
                      />
                    </Form.Item>
                  </div>
                  <div className="bottom-spacing">
                    <Form.Item name="email">
                      <Input size="large" placeholder="Enter your email" />
                    </Form.Item>
                  </div>
                  <div className="">
                    <Form.Item name="designation">
                      <Input size="large" placeholder="Enter your Designation" />
                    </Form.Item>
                  </div>
                  <Button type="default" htmlType="submit" className="submit-btn" block size="large" loading={loading.formLoading}>
                    Submit
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhiteLabelInquiryForm;
